import { useCallback } from "react";
import { Boxes } from "lucide-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import Authorized from "components/Authorized";
import { getNextQueryParams } from "components/helpers";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import FormDialog from "components/modals/FormDialog";
import {
  invalidateProductLinesQuery,
  useProductLinesTable,
} from "hooks/useProductLinesTable";
import ProductLineForm from "routes/product_line/ProductLineForm";
import ProductLineService from "services/ProductLine";

export const PRODUCT_LINES_TABLE_CONSTANTS = {
  tableName: "product_lines",
  queryKey: "productLines",
  className: "ProductLine",
  exportTableName: null,
  header: "Product Lines",
  headerIcon: Boxes,
};

const CREATE_ACLS = [ACL_RELATIONSHIPS.productLine.create];

const ProductLinesTableV3 = () => {
  const { columns } = useProductLinesTable();

  const fetchProductLines = useCallback(
    async queryParams => {
      const nextQueryParams = getNextQueryParams(queryParams, columns);
      return ProductLineService.getTable(nextQueryParams);
    },
    [columns]
  );

  return (
    <BaseTableV3
      columns={columns}
      headerIcon={PRODUCT_LINES_TABLE_CONSTANTS.headerIcon}
      header={PRODUCT_LINES_TABLE_CONSTANTS.header}
      queryKey={PRODUCT_LINES_TABLE_CONSTANTS.queryKey}
      className={PRODUCT_LINES_TABLE_CONSTANTS.className}
      tableName={PRODUCT_LINES_TABLE_CONSTANTS.tableName}
      createButton={
        <Authorized permissions={CREATE_ACLS}>
          <FormDialog
            FormComponent={ProductLineForm}
            modelType="Product Line"
            onSuccess={invalidateProductLinesQuery}
          />
        </Authorized>
      }
      fetchData={fetchProductLines}
      invalidateData={invalidateProductLinesQuery}
      enableSettings
    />
  );
};

export default ProductLinesTableV3;
